/* eslint-disable react/require-default-props */
// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function OtherInstruments({
  humiditySensorList = [],
  pressureSensorList = [],
  temperatureSensorList = [],
  waterVaporSensorList = [],
  frequencyStandardSensorList = [],
}) {
  return (
    <div className="tab-pane fade" id="other-tab-pane" role="tabpanel" aria-labelledby="other-tab" tabIndex="0">
      <div className="instrument--list">
        <div className="instrument--list__container">
          <h1>Humidity Sensor</h1>
          {(humiditySensorList.length === 0)
          && (
          <div>
            <p className="not_installed">No humidity sensor</p>
          </div>
          )}
          {(humiditySensorList.length !== 0) && humiditySensorList.map((elem) => (
            <div
              key={elem.currentDateId}
            >
              <p key={elem.sensor_model_id}><span className="name">Model: </span>{elem.sensor_model}</p>
              <p key={elem.sensor_serial_number_id}><span className="name">Serial number: </span>{elem.sensor_serial_number}</p>
              <p key={elem.sensor_manufacturer_id}><span className="name">Manufacturer: </span>{elem.sensor_manufacturer}</p>
              <p key={elem.sensor_data_sampling_interval_id}><span className="name">Data sampling interval:</span>{elem.sensor_data_sampling_interval}</p>
              <p key={elem.sensor_accuracy_id}><span className="name">Accuracy: </span>{elem.sensor_accuracy}</p>
              <p key={elem.sensor_height_diff_to_ant_id}><span className="name">Height diff. to ant:</span>{elem.sensor_height_diff_to_ant}</p>
              <p key={elem.sensor_calibration_date_id}><span className="name">Calibration date:</span>{elem.sensor_calibration_date}</p>
              <p key={elem.sensor_aspiration_id}><span className="name">Aspiration: </span>{elem.sensor_aspiration}</p>
              <p key={elem.datefromId}><span className="name">Date from: </span>{elem.datefrom}</p>
              <p key={elem.datetoId}><span className="name">Date to:</span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p key={elem.commentId}><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
        <div className="instrument--list__container">
          <h1>Pressure Sensor</h1>
          {(pressureSensorList.length === 0)
          && (
            <div>
              <p className="not_installed">No pressure sensor</p>
            </div>
          )}
          {(pressureSensorList.length !== 0) && pressureSensorList.map((elem) => (
            <div key={elem.currentDateId}>
              <p><span className="name">Model: </span>{elem.sensor_model}</p>
              <p><span className="name">Serial number: </span>{elem.sensor_serial_number}</p>
              <p><span className="name">Manufacturer: </span>{elem.sensor_manufacturer}</p>
              <p><span className="name">Data sampling interval: </span>{elem.sensor_data_sampling_interval}</p>
              <p><span className="name">Accuracy: </span>{elem.sensor_accuracy}</p>
              <p><span className="name">Height diff. to ant: </span>{elem.sensor_height_diff_to_ant}</p>
              <p><span className="name">Calibration date: </span>{elem.sensor_calibration_date}</p>
              <p><span className="name">Aspiration: </span>{elem.sensor_aspiration}</p>
              <p><span className="name">Date from: </span>{elem.datefrom}</p>
              <p><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
        <div className="instrument--list__container">
          <h1>Temperature Sensor</h1>
          {(temperatureSensorList.length === 0)
          && (
            <div>
              <p className="not_installed">No temperature sensor</p>
            </div>
          )}
          {(temperatureSensorList.length !== 0) && temperatureSensorList.map((elem) => (
            <div key={elem.currentDateId}>
              <p><span className="name">Model: </span>{elem.sensor_model}</p>
              <p><span className="name">Serial number: </span>{elem.sensor_serial_number}</p>
              <p><span className="name">Manufacturer: </span>{elem.sensor_manufacturer}</p>
              <p><span className="name">Data sampling interval: </span>{elem.sensor_data_sampling_interval}</p>
              <p><span className="name">Accuracy: </span>{elem.sensor_accuracy}</p>
              <p><span className="name">Height diff. to ant: </span>{elem.sensor_height_diff_to_ant}</p>
              <p><span className="name">Calibration date: </span>{elem.sensor_calibration_date}</p>
              <p><span className="name">Aspiration: </span>{elem.sensor_aspiration}</p>
              <p><span className="name">Date from: </span>{elem.datefrom}</p>
              <p><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
        <div className="instrument--list__container">
          <h1>Water vapor radiometer</h1>
          {(waterVaporSensorList.length === 0)
          && (
          <div>
            <p className="not_installed">No water vapor radiometer</p>
          </div>
          )}
          {(waterVaporSensorList.length !== 0) && waterVaporSensorList.map((elem) => (
            <div key={elem.currentDateId}>
              <p><span className="name">Water vapor radiometer: </span>{elem.sensor_water_vapor_radiometer}</p>
              <p><span className="name">Serial number: </span>{elem.sensor_serial_number}</p>
              <p><span className="name">Manufacturer: </span>{elem.sensor_manufacturer}</p>
              <p><span className="name">Height diff. to ant: </span>{elem.sensor_height_diff_to_ant}</p>
              <p><span className="name">Calibration date: </span>{elem.sensor_calibration_date}</p>
              <p><span className="name">Distance to antenna: </span>{elem.sensor_distance_to_antenna}</p>
              <p><span className="name">Date from: </span>{elem.datefrom}</p>
              <p><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
        <div className="instrument--list__container">
          <h1>Frequency standard</h1>
          {(frequencyStandardSensorList.length === 0)
          && (
            <div>
              <p className="not_installed">No frequency standard</p>
            </div>
          )}
          {(frequencyStandardSensorList.length !== 0) && frequencyStandardSensorList.map((elem) => (
            <div key={elem.currentDateId}>
              <p><span className="name">Standard type: </span>{elem.sensor_standard_type}</p>
              <p><span className="name">Input frequency: </span>{elem.sensor_input_frequency}</p>
              <p><span className="name">Date from: </span>{elem.datefrom}</p>
              <p><span className="name">Date to: </span>{elem.currentDate === elem.dateto ? '' : elem.dateto}</p>
              <p><span className="name">Comment: </span>{elem.comment}</p>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

OtherInstruments.propTypes = {
  humiditySensorList: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  pressureSensorList: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  temperatureSensorList: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  waterVaporSensorList: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
  frequencyStandardSensorList: PropTypes.arrayOf(
    PropTypes.shape({}),
  ),
};

export default OtherInstruments;
